module.exports = __webpack_public_path__ + "static/media/stevens.20950b57.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/stevens.jpg
// module id = 211
// module chunks = 0